'use client';

import { useEffect } from 'react';

import analyticsManager from '@/lib/analytics';
import { EventPayload } from '@/lib/analytics/types';

const ClientAnalyticsTracker = (eventPayload: EventPayload) => {
  useEffect(() => {
    analyticsManager.client.sendEvent(eventPayload);
  }, [eventPayload]);

  return null;
};

export default ClientAnalyticsTracker;
